import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { LocationStore } from '../stores/location.store';

@Injectable({
  providedIn: 'root',
})
export class LocationListsResolver implements Resolve<void> {
  private readonly locationStore = inject(LocationStore);

  async resolve(route: ActivatedRouteSnapshot): Promise<void> {
    const id = Number(route.paramMap.get('id'));
    await this.locationStore.getLocationsByAsset(id);

    return Promise.resolve();
  }
}
